export default "__VITE_ASSET__DHW7avrM__"